import { ICellRendererParams } from "ag-grid-community";
import { Stack, Typography } from "@mui/joy";
import ReactRouterLink from "@/components/ReactRouterLink/ReactRouterLink";
import { AgentObj } from "@/types/interfaces/agents";

export const LinkedCellRenderer = ({
  data,
  value,
  replaceText,
}: ICellRendererParams<AgentObj> & { replaceText?: string }) => (
  <Stack direction="row" alignItems="center" gap={1}>
    <Typography
      component={ReactRouterLink}
      noWrap
      textColor="text.primary"
      to={`/admin/agents/profile?email=${encodeURIComponent(data?.ttandEmail || "")}`}
      fontWeight="md"
      sx={{ mr: 1, fontSize: "inherit", "&:hover": { color: "primary.plainColor", textDecoration: "underline" } }}
    >
      {replaceText ? value?.replace(replaceText, "") : value}
    </Typography>
  </Stack>
);
